module.exports = __webpack_public_path__ + "img/playMrkt-odrex.b720ed86.svg";